import { render, staticRenderFns } from "./tool-damages-accordion.vue?vue&type=template&id=677f0e57&scoped=true&"
import script from "./tool-damages-accordion.vue?vue&type=script&lang=js&"
export * from "./tool-damages-accordion.vue?vue&type=script&lang=js&"
import style0 from "./tool-damages-accordion.vue?vue&type=style&index=0&id=677f0e57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f0e57",
  null
  
)

export default component.exports